import { createSelector } from 'reselect'
import { formattedFileSelector } from 'containers/Project/FileSection/selectors'
import { isImageFile } from 'helpers/imageUtil'

const filePreviewSelector = (state) => state.filePreview

const filePreviewLoadingSelector = createSelector(
  filePreviewSelector,
  (filePreview) => filePreview.loading
)

const filePreviewLinkSelector = createSelector(
  filePreviewSelector,
  (filePreview) => filePreview.fileLink
)

const filePreviewNameSelector = createSelector(
  filePreviewSelector,
  (filePreview) => filePreview.fileName
)

const filePreviewIdSelector = createSelector(
  filePreviewSelector,
  (filePreview) => filePreview.fileId
)

const filePreviewShowSelector = createSelector(
  filePreviewSelector,
  (filePreview) => filePreview.show
)

const filteredFilesSelector = createSelector(
  formattedFileSelector,
  (files) => 
    files.filter(file => {
      return file && isImageFile(file.name)
    })
)

const nextFileSelector = createSelector(
  filteredFilesSelector,
  filePreviewIdSelector,
  (files, currentId) => {
    const currentFileIndex = files.findIndex((file) => file && file.fileId === currentId)
    const nextFileIndex = (currentFileIndex + 1 < files.length) ? currentFileIndex + 1 : 0
    return files[nextFileIndex]
  }
)

const prevFileSelector = createSelector(
  filteredFilesSelector,
  filePreviewIdSelector,
  (files, currentId) => {
    const currentFileIndex = files.findIndex((file) => file && file.fileId === currentId)
    const prevFileIndex = (currentFileIndex - 1 >= 0) ? currentFileIndex - 1 : files.length - 1
    return files[prevFileIndex]
  }
)

export {
  filteredFilesSelector,
  filePreviewLoadingSelector,
  filePreviewLinkSelector,
  filePreviewNameSelector,
  filePreviewShowSelector,
  nextFileSelector,
  prevFileSelector
}
